var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, EventEmitter, Injector } from '@angular/core';
import { NameValueOfString } from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';
import { AppConsts } from '@shared/AppConsts';
var DeliveryWithMultiselectComponent = /** @class */ (function (_super) {
    __extends(DeliveryWithMultiselectComponent, _super);
    function DeliveryWithMultiselectComponent(injector) {
        var _this = _super.call(this, injector) || this;
        _this._exclude = [];
        _this.name = 'DeliveryWithFilter';
        _this.selectedItemsChange = new EventEmitter();
        _this.deliveryWithValues = AppConsts.deliveryWith;
        _this.options = new Array();
        _this._selectedItems = [];
        _this.placeholder = _this.l('DeliveryWith');
        return _this;
    }
    Object.defineProperty(DeliveryWithMultiselectComponent.prototype, "selectedItems", {
        get: function () {
            return this._selectedItems;
        },
        set: function (items) {
            this._selectedItems = items || [];
            this.selectedItemsChange.emit(this._selectedItems);
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(DeliveryWithMultiselectComponent.prototype, "exclude", {
        set: function (exclude) {
            this._exclude = exclude;
            this.setDeliveryWithOptions();
        },
        enumerable: true,
        configurable: true
    });
    DeliveryWithMultiselectComponent.prototype.ngOnInit = function () {
        this.setDeliveryWithOptions();
    };
    DeliveryWithMultiselectComponent.prototype.deliveryWithKeys = function () {
        return [this.deliveryWithValues.ed, this.deliveryWithValues.onForwarder, this.deliveryWithValues.threePL];
    };
    DeliveryWithMultiselectComponent.prototype.setDeliveryWithOptions = function () {
        var _this = this;
        this.options = [];
        this.deliveryWithKeys().forEach(function (e) {
            if (!_this._exclude.includes(e)) {
                _this.options.push(new NameValueOfString({ name: _this.l(e), value: e }));
            }
        });
    };
    DeliveryWithMultiselectComponent.prototype.onPanelHide = function () {
        document.getElementById(this.name).focus();
    };
    return DeliveryWithMultiselectComponent;
}(AppComponentBase));
export { DeliveryWithMultiselectComponent };
